import { useMemo } from 'react'
import styles from './Subheader.module.css'

let Subheader = ({ children, subtitle, date, ...rest }) => {
  let currentDate = useMemo(() => new Date().toLocaleDateString('de-DE', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }), [])

  return (
    <div {...rest}>
      <div className={styles.subheader}>{children}</div>
      {subtitle && <div className="subtitle2">{subtitle}</div>}
      {date && <div className="subtitle2 dark:text-gray-400">Deine Übersicht für den {currentDate}</div>}
    </div>
  )
}

export default Subheader
